/** 読み込み中の印。回る魔法陣と 1 行の文を出す。inline は文の横に小さく並べる */
export default function Loading({ label = "読み込み中・・・", inline }: { label?: string; inline?: boolean }) {
  return (
    <div className={inline ? "ui-loading ui-loading-inline" : "ui-loading"} role="status">
      <img className="ui-loading-ring" src="/ui/icon-loading.webp" alt="" width={160} height={160} />
      <span>{label}</span>
    </div>
  );
}
